export default __webpack_public_path__ + "static/media/contactside.2648b0e3.jpg";